"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMedia = void 0;
var mediaMap = new Map();
var getMedia = function (query) {
    var instance = mediaMap.get(query);
    if (instance !== undefined) {
        return instance;
    }
    var media = window.matchMedia(query);
    if (media.addEventListener === undefined) {
        media.addEventListener = function (event, listener, options) {
            return media.addListener(listener);
        };
    }
    if (media.removeEventListener === undefined) {
        media.removeEventListener = function (event, listener) {
            return media.removeListener(listener);
        };
    }
    mediaMap.set(query, media);
    return media;
};
exports.getMedia = getMedia;
